// store/singlePostSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAuthToken } from '../utils/auth'

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://pro.vibelinksapp.com/api'

export const fetchSinglePost = createAsyncThunk(
  'singlePost/fetchSinglePost',
  async (postId, { rejectWithValue }) => {
    try {
      const token = getAuthToken()
      const response = await axios.post(
        `${BASE_URL}/get-post-detail`,
        { post_id: postId },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      return response.data.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message)
    }
  }
)

const initialState = {
  post: null,
  loading: false,
  error: null
}

const singlePostSlice = createSlice({
  name: 'singlePost',
  initialState,
  reducers: {
    clearSinglePost (state) {
      state.post = null
      state.loading = false
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSinglePost.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchSinglePost.fulfilled, (state, action) => {
        state.loading = false
        state.post = action.payload
      })
      .addCase(fetchSinglePost.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearSinglePost } = singlePostSlice.actions
export default singlePostSlice.reducer
